import { injectable } from 'inversify';
import { resolve } from '@/app/container';
import { EventStreamListener } from '@/app/event-stream';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import { ObjectCompletedEventName, ObjectEvent } from '@/app/statistics/events/object-completion-events';
import { CompetenceUpdatedEventName } from '@/app/competence/events/competence-events';
import { CompetenceService, CompetenceServiceSymbol } from '../competence-service';
import objectCompletionStoreModule from '@/app/statistics/state/object-completion-state';

@injectable()
export class CalculateCompetences implements EventStreamListener {
  public get events(): string[] {
    return [
      ObjectCompletedEventName
    ];
  }

  public handle(event: ObjectEvent): void {
    objectCompletionStoreModule.setObjectCompleted(event.payload.id);

    const service = resolve<CompetenceService>(CompetenceServiceSymbol);
    service.calculateAndSetToStore();

    const eventStream: EventStream = resolve<EventStream>(EventStreamSymbol);
    eventStream.dispatch({
      payload: {},
      name: CompetenceUpdatedEventName
    });
  }
}
